import apiCodes from './api-codes';

export default {
    apiCodes
};